import { Injectable } from "@angular/core";
import {
  RequestSaveChangeDto,
  ResponseGetAllDataEmpDto,
  ResponseSaveChangeDto
} from "../../shared/nestjs/gd-only/dto/sf-change-spv.dto";
import {
  RequestGetCompanyDto,
  ResponseGetCompanyDto
} from "../../shared/nestjs/gd-only/dto/sf-company.dto";
import { ResponseGetListEmpRehireDto } from "../../shared/nestjs/gd-only/dto/sf-profile.dto";
import { SfChangeSpvApi } from "../../shared/nestjs/gd-only/services/sf-change-spv.api";
import { SfCompanyApi } from "../../shared/nestjs/gd-only/services/sf-company.api";
import { SfProfileApi } from "../../shared/nestjs/gd-only/services/sf-profile.api";
import { SFChangeSpvApi, SFCompanyApi, SFSearchApi } from "../../shared/sdk/services/custom";
import { SearchEmployeeRehireParam } from "./emp-rehire.logic";

@Injectable()
export class SharedLogic {
  constructor(
    private sfChangeSpvApi: SfChangeSpvApi,
    private SFChangeSpvApi: SFChangeSpvApi,
    private sfprofileApi: SfProfileApi,
    private SFSearchApi: SFSearchApi,
    private sfCompanyApi: SfCompanyApi,
    private SFCompanyApi: SFCompanyApi,
  ) {
  }

  getAllDataEmpNest(): Promise<ResponseGetAllDataEmpDto> {
    return new Promise<ResponseGetAllDataEmpDto>((resolve, reject) => {
      const getAllDataEmp = this.sfChangeSpvApi.getAllDataEmp().subscribe(
        (result) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        },
        () => {
          getAllDataEmp.unsubscribe();
        }
      )
    })
  }

  getCompanyNest(payload: RequestGetCompanyDto): Promise<ResponseGetCompanyDto> {
    return new Promise<ResponseGetCompanyDto>((resolve, reject) => {
      const getCompany = this.sfCompanyApi.getCompany(payload).subscribe(
        (result) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        },
        () => {
          getCompany.unsubscribe();
        }
      )
    })
  }

  getCompanyLB(payload: RequestGetCompanyDto): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const getCompany = this.SFCompanyApi.getCompany(payload).subscribe(
        (result) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        },
        () => {
          getCompany.unsubscribe();
        }
      )
    })
  }

  getAllDataEmpLB(companyId): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const getAllDataEmp = this.SFChangeSpvApi.getAllDataEmp({ companyId }).subscribe(
        (result) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        },
        () => {
          getAllDataEmp.unsubscribe();
        }
      )
    })
  }

  saveChangeLB(payload): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const saveChange = this.SFChangeSpvApi.saveChange(payload).subscribe(
        (result) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        },
        () => {
          saveChange.unsubscribe();
        }
      )
    })
  }

  saveChangePartialLB(data, head): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const saveChangePartial = this.SFChangeSpvApi.saveChangePartial(data, head).subscribe(
        (result) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        },
        () => {
          saveChangePartial.unsubscribe();
        }
      )
    })
  }

  saveChangeNest(payload: RequestSaveChangeDto): Promise<ResponseSaveChangeDto> {
    return new Promise<ResponseSaveChangeDto>((resolve, reject) => {
      const saveChange = this.sfChangeSpvApi.saveChange(payload).subscribe(
        (result) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        },
        () => {
          saveChange.unsubscribe();
        }
      )
    })
  }

  searchEmployeeRehire(data: SearchEmployeeRehireParam): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const searchEmployeeRehire = this.SFSearchApi.getEmployeeRehire(data).subscribe(
        (result) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        },
        () => {
          searchEmployeeRehire.unsubscribe();
        }
      )
    })
  }

  getListEmpRehireNest(limit: string | number, page: string | number, q: string): Promise<ResponseGetListEmpRehireDto> {
    return new Promise<ResponseGetListEmpRehireDto>((resolve, reject) => {
      const getListEmpRehire = this.sfprofileApi.getListEmpRehire(limit, page, q).subscribe(
        (result) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        },
        () => {
          getListEmpRehire.unsubscribe();
        }
      )
    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/component-logic/shared.logic.ts